import { useContext, useRef, useState } from 'react';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import {
  createCrossoutContainer,
  renderToolbar,
  getQuestionByReference,
  addPropsToNodes,
  getItemByRef,
} from 'chameleon/packages/blue-book-player/utils';
import useListenToRenderedQuestions from 'chameleon/packages/blue-book-player/hooks/useListenToRenderedQuestions';
import { BluebookContext } from '../state/BluebookContext';
import { DynamicQuestionsContext } from '../state/DynamicQuestionContext';
import { getIndexOfSingleQuestionPreview } from 'chameleon/packages/blue-book-player/utils';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';

const CrossOutInjector = ({
  crossOutReducer,
  isStudentAccount,
  isSingleQuestionPreview,
  previewData,
  learnosityApp,
  learnosityItemsRef,
}) => {
  const { state: playerState } = useContext(BluebookContext);
  const { state: { currentItemId } = {} } =
    useContext(DynamicQuestionsContext) || {};

  const playerEl = useGetPlayerEl();
  const loadedQuestions = useRef([]);
  const [nodes, setNodes] = useState([]);
  const { isApcDataLoading, questions } = playerState;

  const doInject = (reference, questionApi) => {
    const question = getQuestionByReference(reference, questions);
    if (!loadedQuestions.current[question.itemId]) {
      loadedQuestions.current[question.itemId] = true;

      const items = learnosityApp?.getItems();
      const currentItem = items?.[reference];
      const itemFeaturesLength = currentItem?.features?.length || 0;
      const itemQuestionsLength = currentItem?.questions?.length || 0;

      const questionNr = isSingleQuestionPreview
        ? getIndexOfSingleQuestionPreview(previewData, currentItemId, reference)
        : learnosityItemsRef.current.indexOf(reference) + 1;

      let contentSelector;
      let className;
      if (itemFeaturesLength === 1 && itemQuestionsLength > 1) {
        contentSelector = SELECTORS.SHARED_PASSAGE_CONTAINER;
      } else if (itemFeaturesLength === 0 && itemQuestionsLength > 1) {
        //Captures the case when there are multiple question widgets
        contentSelector = `${SELECTORS.QUESTION_WIDGET} ${SELECTORS.QUESTION}`;
        const questionWidgets = getItemByRef(
          playerEl,
          reference,
        )?.querySelectorAll(contentSelector);
        //Captures the case when the first widget loads async and there is no content
        if (questionWidgets?.length < 2) {
          const { response_id } = currentItem?.questions?.[0] || {};
          if (response_id) {
            contentSelector = `[data-lrn-widget-container="${response_id}"]`;
            className = 'is-above-widgets';
          }
        }
      } else {
        contentSelector = SELECTORS.QUESTION;
      }

      createCrossoutContainer(
        reference,
        playerEl,
        contentSelector,
        className,
      ).then((el) => {
        setNodes((currentNodes) => [
          ...currentNodes,
          renderToolbar(el, {
            isStudentAccount,
            questionNr,
            question,
            crossOutReducer,
            canMask: questionApi?.isMaskable(),
            learnosityQuestionApi: questionApi,
          }),
        ]);
      });
    }
  };

  useListenToRenderedQuestions(playerState, learnosityApp, doInject);

  if (isApcDataLoading) {
    return null;
  }

  return addPropsToNodes(nodes, {
    crossOutReducer,
  });
};

export default CrossOutInjector;
